import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {IWastyRecipient} from "../../../../../../utils/interfaces/special_wasty/wasty_recipient/IWastyRecipient";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";


const useApiGetWastyRecipient = (pk: number | undefined): UseQueryResult<IWastyRecipient, CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(pk: number | undefined): Promise<IWastyRecipient> {
        try {
            const response = await get(`/api/company/${selectedCompany?.company_token}/special_wasty/wasty_recipient/${pk}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetWastyRecipient", pk],
        queryFn: () => doGet(pk),
        enabled: !!pk,
    })

};

export default useApiGetWastyRecipient